import React from "react"
import ReactDOM from "react-dom"
import IconLinkContainerComponent from "./icon-link-container-component"

export default class IconLinkContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<IconLinkContainerComponent {...self.modelJson} />, self.elem)
  }
}
